import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { CopilotSuggestionsOverview } from '@/features/copilot/overview'

const copilotSearchSchema = z.object({
  instanceId: z.number().int().optional(),
  queryDigest: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/copilot/')({
  validateSearch: copilotSearchSchema,
  component: CopilotSuggestionsOverview,
})
